// List of available character images for Compose Sentences Page
const characterImages = [
  "/assets/profile-characters/agus-transparent.png",
  "/assets/profile-characters/aksa1-transparent.png",
  "/assets/profile-characters/aksa2-transparent.png",
  "/assets/profile-characters/edi-transparent.png",
  "/assets/profile-characters/judika-transparent.png",
  "/assets/profile-characters/maria-transparent.png",
  "/assets/profile-characters/poltak-transparent.png",
  "/assets/profile-characters/roger-transparent.png",
];

export default characterImages;
